/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import { QueryErrorResetBoundary } from 'react-query';
import { ErrorBoundary } from 'react-error-boundary';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { sendErrorReport } from '../../api';
import { useNavigate } from 'react-router-dom';

function OopsComponent({ resetErrorBoundary }) {
  const navigate = useNavigate();
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={1}
      sx={{
        height: '100vh',
        backgroundColor: (theme) => theme.palette.grey[200],
      }}
    >
      <Typography variant="h2">Oops!</Typography>
      <Typography variant="h5">Something went wrong</Typography>
      <Button
        variant="contained"
        onClick={() => {
          resetErrorBoundary();
          navigate('/');
        }}
      >
        TRY AGAIN
      </Button>
    </Stack>
  );
}

export default function UnexpectedError({ children }) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          onError={sendErrorReport}
          FallbackComponent={OopsComponent}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
